import formName from 'constants/formName'
import { StateType, WhitelistAddressFormType, WhitelistAddressStepType } from 'data/types'
import { getFormValues as reduxGetFormValues } from 'redux-form'
import { createSelector } from 'reselect'

import payments from '../../Payments/selectors'

const getInitialValues: (state: StateType) => WhitelistAddressFormType = createSelector(
  payments.hasWhitelistedAddresses,
  (hasWhitelistedAddresses) => {
    if (hasWhitelistedAddresses) {
      return { currency: 'BTC', loading: false, step: 'listaddresses' }
    }
    return { currency: 'BTC', loading: false, step: 'setup' }
  }
)

// FIXME "as WhitelistAddressFormType" should not be needed as type should be infered, find out what's missing
const getValues = (state: StateType): WhitelistAddressFormType => {
  const values = reduxGetFormValues(formName.WHITELIST_ADDRESS)(state) as WhitelistAddressFormType
  if (values) return values
  return getInitialValues(state)
}

const getStep: (state: StateType) => WhitelistAddressStepType = createSelector(
  getValues,
  (form) => form.step
)

const isLoading: (state: StateType) => boolean = createSelector(getValues, (form) => form.loading)

export default {
  getInitialValues,
  getStep,
  getValues,
  isLoading
}
